import { render, staticRenderFns } from "./TenderTags.vue?vue&type=template&id=76504ee2&scoped=true"
import script from "./TenderTags.vue?vue&type=script&lang=js"
export * from "./TenderTags.vue?vue&type=script&lang=js"
import style0 from "./TenderTags.vue?vue&type=style&index=0&id=76504ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76504ee2",
  null
  
)

export default component.exports